<div class="auth-header">
  <a href="/">
    <adex-image src="adex_logo"></adex-image>
  </a>
</div>
<div class="auth-main-content-container">
  <router-outlet></router-outlet>
</div>
